import React, { useState } from 'react'
import './OnTheDay.css'
import onTheDayImg from '../../Assets/custom-site/ontheday.webp'

const OnTheDay = ({ colourScheme, meals = [], whatToExpect = "", barInfo = "", dressCode = "" }) => {
    const [openSections, setOpenSections] = useState({
        whatToExpect: false,
        dressCode: false,
        theBar: false,
        foodAndDrink: false
    });

    const toggleSection = (section) => {
        setOpenSections(prev => ({
            ...prev,
            [section]: !prev[section]
        }));
    };

    // Helper function to generate dietary identifiers
    const getDietaryIdentifiers = (meal) => {
        const identifiers = [];
        if (meal.vegetarian === true) identifiers.push('(v)');
        if (meal.vegan === true) identifiers.push('(vg)');
        if (meal.glutenFree === true) identifiers.push('(gf)');
        return identifiers.length > 0 ? ` ${identifiers.join('')}` : '';
    };

    return (
        <div className={`ontheday-container ${colourScheme}-ontheday`}>
            <div className="ontheday-inner">
                <h2 className="ontheday-title">On The Day</h2>
                <div className="ontheday-right-image">
                    <img src={onTheDayImg} alt="On the day" />
                </div>

                {/* Content columns */}
                <div className="ontheday-content">
                    <div className="ontheday-col">
                        <div className="ontheday-accordion-item">
                            <button 
                                className="ontheday-accordion-header"
                                onClick={() => toggleSection('whatToExpect')}
                            >
                                <h3 className="ontheday-subtitle">What to expect</h3>
                                <span className={`ontheday-accordion-icon ${openSections.whatToExpect ? 'open' : ''}`}>{openSections.whatToExpect ? '−' : '+'}</span>
                            </button>
                            <div className={`ontheday-accordion-content ${openSections.whatToExpect ? 'open' : ''}`}>
                                <p className="ontheday-text">{whatToExpect || "Small placeholder paragraph about the day's flow and any key timings."}</p>
                            </div>
                        </div>

                        <div className="ontheday-accordion-item">
                            <button 
                                className="ontheday-accordion-header"
                                onClick={() => toggleSection('dressCode')}
                            >
                                <h3 className="ontheday-subtitle">Dress Code</h3>
                                <span className={`ontheday-accordion-icon ${openSections.dressCode ? 'open' : ''}`}>{openSections.dressCode ? '−' : '+'}</span>
                            </button>
                            <div className={`ontheday-accordion-content ${openSections.dressCode ? 'open' : ''}`}>
                                <p className="ontheday-text">{dressCode || "Small placeholder paragraph describing the preferred dress code for guests."}</p>
                            </div>
                        </div>

                        <div className="ontheday-accordion-item">
                            <button 
                                className="ontheday-accordion-header"
                                onClick={() => toggleSection('theBar')}
                            >
                                <h3 className="ontheday-subtitle">The Bar</h3>
                                <span className={`ontheday-accordion-icon ${openSections.theBar ? 'open' : ''}`}>{openSections.theBar ? '−' : '+'}</span>
                            </button>
                            <div className={`ontheday-accordion-content ${openSections.theBar ? 'open' : ''}`}>
                                <p className="ontheday-text">{barInfo || "Small placeholder paragraph with details about the bar and drinks arrangements."}</p>
                            </div>
                        </div>
                    </div>

                    <div className="ontheday-col">
                        <div className="ontheday-accordion-item">
                            <button 
                                className="ontheday-accordion-header"
                                onClick={() => toggleSection('foodAndDrink')}
                            >
                                <h3 className="ontheday-subtitle">Food And Drink</h3>
                                <span className={`ontheday-accordion-icon ${openSections.foodAndDrink ? 'open' : ''}`}>{openSections.foodAndDrink ? '−' : '+'}</span>
                            </button>
                            <div className={`ontheday-accordion-content ${openSections.foodAndDrink ? 'open' : ''}`}>
                                {meals.filter(meal => meal.course === 'Starter').length > 0 && (
                                    <div>
                                        <h4 className={`ontheday-subtitle-secondary ${colourScheme}-highlight`} style={{ marginTop: '34px' }}>Starters</h4>
                                        {meals.filter(meal => meal.course === 'Starter').map((meal, idx) => (
                                            <p key={idx} className="ontheday-text ontheday-meal-item">
                                                {meal.name}{meal.description ? ` - ${meal.description}` : ''}{getDietaryIdentifiers(meal)}
                                            </p>
                                        ))}
                                    </div>
                                )}
                                {meals.filter(meal => meal.course === 'Main').length > 0 && (
                                    <div>
                                        <h4 className={`ontheday-subtitle-secondary ${colourScheme}-highlight`} style={{ marginTop: '34px' }}>Main Course</h4>
                                        {meals.filter(meal => meal.course === 'Main').map((meal, idx) => (
                                            <p key={idx} className="ontheday-text ontheday-meal-item">
                                                {meal.name}{meal.description ? ` - ${meal.description}` : ''}{getDietaryIdentifiers(meal)}
                                            </p>
                                        ))}
                                    </div>
                                )}
                                {meals.filter(meal => meal.course === 'Dessert').length > 0 && (
                                    <div>
                                        <h4 className={`ontheday-subtitle-secondary ${colourScheme}-highlight`} style={{ marginTop: '34px' }}>Dessert</h4>
                                        {meals.filter(meal => meal.course === 'Dessert').map((meal, idx) => (
                                            <p key={idx} className="ontheday-text ontheday-meal-item">
                                                {meal.name}{meal.description ? ` - ${meal.description}` : ''}{getDietaryIdentifiers(meal)}
                                            </p>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Mobile bottom image */}
            <div className="ontheday-bottom-image">
                <img src={onTheDayImg} alt="On the day" />
            </div>
        </div>
    )
}

export default OnTheDay
